// Helpers for detecting failing/retake-eligible exam result rows.
// Used by the Supplementary / Re-upload flow so we only mutate scores
// for modules a student previously failed (FAIL / SUPP / INC / REPEAT).

export const FAILING_REMARKS = new Set([
  "FAIL",
  "SUPP",
  "INC",
  "INCOMPLETE",
  "REPEAT",
]);

export const FAILING_GRADES = new Set([
  "F",
  "D",
  "D+",
  "D-",
  "E",
  "I",
  "INC",
  "SUPP",
]);

export interface ExamResultLike {
  remark?: string | null;
  overall_remark?: string | null;
  grade?: string | null;
}

export function isFailingResult(row: ExamResultLike | null | undefined): boolean {
  if (!row) return false;
  const remark = (row.remark || "").toUpperCase().trim();
  const overall = (row.overall_remark || "").toUpperCase().trim();
  const grade = (row.grade || "").toUpperCase().trim();
  if (FAILING_REMARKS.has(remark)) return true;
  if (FAILING_REMARKS.has(overall)) return true;
  if (FAILING_GRADES.has(grade)) return true;
  return false;
}
